import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();
let userData = JSON.parse(localStorage.getItem("tokenData"))

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getImportEvent(game, date) {
    try {
        const response = await serviceContext.get("betfair/builder/events/" + game + "/" + date, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getActiveMarkets() {
    try {
        const response = await serviceContext.get("admin/eventcontrol", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAdminEventControl() {
    let url = ""
    url = "usermgnt/event/masters"
    try {
        const response = await serviceContext.get(url, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAdminEventType() {
    let url = ""
    url = `${ReportsURL}result/open`;//ReportsURL + "results/open"
    try {
        const response = await serviceContext.get(url, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};



export async function importEvents(data) {
    try {
        const response = await serviceContext.post("admin/eventcontrol", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventTemplate() {
    try {
        const response = await serviceContext.get("admin/mastereventtemplate", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateEventTemplate(data) {
    try {
        const response = await serviceContext.post("admin/mastereventtemplate", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getMarketsFromIdList(data) {
    try {
        const response = await serviceContext.post("admin/marketcontrol/getMarkets", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getFullEvent(eventId) {
    let url = ""
    url = "marketprovider/events/detail/" + eventId
    try {
        const response = await serviceContext.get(url, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function activateEventType(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/activateEventType"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActivateEventType(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/deactivateEventType"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function activateCompetition(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/activateCompetition"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActivateCompetition(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/deactivateCompetition"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function activateEvent(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/activateEvent"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActivateEvent(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/deactivateEvent"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateTvUrl(data) {
    try {
        const response = await serviceContext.put("admin/eventcontrol/updatetvurl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserEventById(eventId) {
    try {
        const response = await serviceContext.get("marketprovider/events/detail/" + eventId, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getMatchedBets(events) {
    try {
        const response = await serviceContext.post("search/bets/master/matched", JSON.stringify(events), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getUnMatchedBets(events) {
    try {
        const response = await serviceContext.post("search/bets/master/unmatched", JSON.stringify(events), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getHomeData(){
    try {
        const response = await serviceContext.get("marketprovider/markets", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function  getEventScore(evt){
    try {
        const response = await serviceContext.get("score/competitions?after=none&has_live_signal=true&competition_id="+evt, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getEventMktMessages(evt) {
    try {
        const response = await serviceContext.get("notification/marketalert/" + evt, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}
